/*!
 * Copyright (C) 2026, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2026-08-27 (jhoward)
 *		- Add hide-room-rates.ts to expose the HIDE_ROOM_RATES env option to the Vue apps.
 */

/**
 * TRUE when hotel room rate information must not be shown anywhere on the front end.
 *
 * Availability is NOT affected by this. The server still sends everything needed to say whether
 * a room or a date is available - only the money is withheld.
 *
 * Mirrors the PHP App\Traits\HidesRoomRates trait, which reads the same .env value. Written the
 * same way as the HSC_OFFER_CODES lookup so an undefined value cannot throw at runtime.
 */
export const HIDE_ROOM_RATES: boolean = (typeof process.env.HIDE_ROOM_RATES === 'string')
  ? 'YES' === process.env.HIDE_ROOM_RATES.toUpperCase()
  : false;

export default HIDE_ROOM_RATES;
